import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import Skeleton from "react-loading-skeleton";
import { Link, useHistory } from "react-router-dom";
import { limitcharactersInString, parseAssetTypeInt } from "../../utils";
//Icons
import { GiRocket } from "react-icons/gi";
import { BsBox } from "react-icons/bs";
import { AiOutlineCloseCircle } from "react-icons/ai";
import useIcons from "../../hooks/useIcons";
import all from "../../services/user/preferences/assets/all";
import useGeneralContext from "../../context/GeneralContext";
import useFollowingAssets from "../../hooks/useFollowingAssets";
import useUserPreferences from "../../hooks/useUserPreferences";

export default function FollowingList() {
  const [defaultAssetsData, setDefaultAssetData] = useState(null);
  const [filteredAssetsData, setFilteredAssetsData] = useState(null);
  const [followingButtonsState, setFollowingButtonsState] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [isLoadingSendRequest, setIsLoadingSendRequest] = useState(false);
  const { setUserFollowingAssets } = useGeneralContext();
  const { addStateAsset, removeStateAsset } = useFollowingAssets();
  const history = useHistory();
  const { getURI } = useIcons();
  const { addAsset, removeAsset } = useUserPreferences();
  const { push } = useHistory();

  //Fetch assets Details.
  useEffect(() => {
    setIsLoadingData(true);
    let fetchData = async () => {
      let request = await all();
      if (request) {
        let status = request.status;
        if (status === 1) {
          //Add the asset data to their states.
          let assetDataDetails = request.data;
          setUserFollowingAssets(assetDataDetails);
          setFilteredAssetsData(assetDataDetails);
          setDefaultAssetData(assetDataDetails);
          //Create Following buttons state.
          let followingState = [];
          assetDataDetails.forEach((item) => {
            followingState.push({
              encodedId: item.encoded_id,
              status: true,
            });
          });
          setFollowingButtonsState(followingState);
          setIsLoadingData(false);
        } else {
          let msg = request.msg;
          if (msg === "empty assets") {
            setDefaultAssetData("empty");
            setIsLoadingData(false);
          } else {
            setDefaultAssetData("error");
            setIsLoadingData(false);
          }
        }
      } else {
        setDefaultAssetData("error");
        setIsLoadingData(false);
      }
    };
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Handle search value and update filteredAssetsData.
  useEffect(() => {
    if (!defaultAssetsData) {
      return null;
    }
    if (searchValue.length > 0) {
      let filteredAssetsData = defaultAssetsData.filter((item) =>
        item.name
          .toLowerCase()
          .replace(/\s/g, "")
          .includes(searchValue.toLowerCase().replace(/\s/g, ""))
      );
      return setFilteredAssetsData(filteredAssetsData);
    } else {
      setFilteredAssetsData(defaultAssetsData);
    }
  }, [searchValue, defaultAssetsData]);

  //Quantity of assets that user follows.
  const qntFollowingAssets = () => {
    let qntFollowing = 0;
    followingButtonsState.forEach((item) => {
      if (item.status) {
        qntFollowing = qntFollowing + 1;
      }
    });
    return qntFollowing;
  };

  //get the actual state of only one button
  const getFollowingButtonState = (assetEncodedId) => {
    if (assetEncodedId) {
      let indexOfItem = followingButtonsState.findIndex(
        (item) => item.encodedId === assetEncodedId
      );
      let buttonState = followingButtonsState[indexOfItem];
      if (buttonState) {
        return buttonState.status;
      }
    }
    return null;
  };

  //Update only one button following state
  const updateFollowingButtonState = (assetEncodedId, newState) => {
    let newFollowingState = followingButtonsState.map((item) => {
      if (item.encodedId === assetEncodedId) {
        item.status = newState;
      }
      return item;
    });
    setFollowingButtonsState(newFollowingState);
  };

  const handleFollowingButtons = async (asset) => {
    const assetEncodedId = asset.encoded_id;

    if (assetEncodedId) {
      setIsLoadingSendRequest(true);
      let actualButtonState = getFollowingButtonState(assetEncodedId);
      if (actualButtonState === true) {
        //*Remove asset from account
        updateFollowingButtonState(assetEncodedId, null);
        let request = await removeAsset(assetEncodedId);
        if (request) {
          let { status } = request;
          if (status === 1) {
            //Add the new state
            updateFollowingButtonState(assetEncodedId, false);
            removeStateAsset(assetEncodedId);
          }
          setIsLoadingSendRequest(false);
        } else {
          updateFollowingButtonState(assetEncodedId, true);
          setIsLoadingSendRequest(false);
        }
      } else {
        //*Add asset
        updateFollowingButtonState(assetEncodedId, null);
        let request = await addAsset(assetEncodedId);
        if (request) {
          let { status } = request;
          if (status === 1) {
            //Update the following status.
            updateFollowingButtonState(assetEncodedId, true);
            addStateAsset({
              name: asset.name,
              country_code: asset.country_code,
              currency_symbol: asset.country_code,
              encoded_id: asset.encoded_id,
              exchange: asset.exchange,
              icon: asset.icon,
              status: 1,
              symbol: asset.symbol,
              type: asset.type,
            });
          }
          setIsLoadingSendRequest(false);
        } else {
          updateFollowingButtonState(assetEncodedId, false);
          setIsLoadingSendRequest(false);
        }
      }
    }
    return null;
  };

  if (isLoadingData) {
    return loadingSkeleton();
  }

  if (defaultAssetsData === "empty") {
    return emptyAssets();
  } else if (defaultAssetsData === "error") {
    return fatalError();
  }

  if (
    defaultAssetsData &&
    defaultAssetsData !== "empty" &&
    defaultAssetsData !== "error"
  ) {
    return (
      <Modal fullscreen={true} show={true} size="md">
        <Modal.Header
          style={{
            position: "sticky",
            top: 0,
            zIndex: 100,
            background: "var(--bg-1)",
          }}
        >
          <div>
            <div className="pos-relative">
              <div className="input-group-text">
                <div className="d-flex pos-absolute t-8 l-25">
                  <i className="icon ion-md-search" />
                </div>
                <input
                  placeholder="Pesquise por ativos..."
                  className="form-control pd-l-30"
                  type="text"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div>
            <span onClick={() => history.goBack()}>
              <AiOutlineCloseCircle
                color="var(--text-1)"
                cursor={"pointer"}
                size={25}
              />
            </span>
          </div>
        </Modal.Header>
        <Modal.Body className={isMobile ? "pd-5" : "pd-10"}>
          {
            //Quantity of results found
            searchValue.length > 0 ? (
              <span className="tx-light mg-l-10">
                Foram encontrados {filteredAssetsData.length} ativos com o termo{" "}
                <span className="tx-semibold">{searchValue}</span>
              </span>
            ) : (
              //Quantity of following now.
              <span className="tx-light mg-b-10 mg-l-10">
                Atualmente você segue
                <span className="tx-semibold"> {qntFollowingAssets()} </span>
                ativos.
              </span>
            )
          }

          <div
            className="pd-10 mx-auto"
            style={
              isMobile
                ? { overflowY: "auto" }
                : { overflowY: "auto", height: 550 }
            }
          >
            <div className="az-profile-work-list">
              {filteredAssetsData.map((item, i) => {
                return (
                  <div key={i}>
                    <div className="media">
                      <div
                        className="media-logo cursor-pointer"
                        onClick={() => push(`/analysis/${item.encoded_id}`)}
                      >
                        <img
                          style={{ borderRadius: "50%" }}
                          width={40}
                          alt=""
                          src={getURI(item.icon)}
                        />
                      </div>
                      <div
                        className="media-body cursor-pointer"
                        onClick={() => push(`/analysis/${item.encoded_id}`)}
                      >
                        <h6>{limitcharactersInString(item.name, 35)}</h6>
                        <span>
                          {parseAssetTypeInt(item.type)}
                          {item.exchange && " (" + item.exchange + ")"}
                        </span>
                      </div>
                      <div
                        className="pd-l-10"
                        style={isLoadingSendRequest ? { opacity: 0.5 } : null}
                        onClick={
                          //Make it unclicable when sending an request is loading.
                          !isLoadingSendRequest
                            ? () => handleFollowingButtons(item)
                            : null
                        }
                      >
                          {getFollowButton(getFollowingButtonState(item.encoded_id))}
                      </div>
                    </div>
                    <hr style={{ backgroundColor: "gray", opacity: 0.1 }} />
                  </div>
                );
              })}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  } else {
    return <div></div>;
  }
}

export const getFollowButton = (status) => {
  let loading = (
    <button
      className="btn btn-primary disabled"
      style={{ borderRadius: 15, height: 20 }}
    >
      <span className="spinner-border spinner-border-sm"></span>
    </button>
  );
  let notFollowing = (
    <button
      className="btn btn-primary"
      style={{ borderRadius: 15, height: 20 }}
    >
      Seguir
    </button>
  );
  let following = (
    <button
      className="btn btn-dark"
      style={{
        borderRadius: 15,
        height: 20,
        backgroundColor: "gray",
        color: "white",
      }}
    >
      Seguindo
    </button>
  );
  if (status === false) {
    return notFollowing;
  } else if (status === null) {
    return loading;
  } else {
    return following;
  }
};

const emptyAssets = () => {
  return (
    <Modal fullscreen={true} show={true} size="md">
      <Modal.Header
        style={{
          position: "sticky",
          top: 0,
          zIndex: 100,
          background: "var(--bg-1)",
        }}
      >
        <div>
          <div className="pos-relative d-none">
            <div className="input-group-text">
              <div className="d-flex pos-absolute t-8 l-25">
                <i className="icon ion-md-search" />
              </div>
              <input
                placeholder="Pesquise por ativos..."
                className="form-control pd-l-30"
                type="text"
                value={""}
                onChange={() => false}
              />
            </div>
          </div>
        </div>
        <div>
          <Link to="/dashboard">
            <AiOutlineCloseCircle color="var(--text-1)" cursor={"pointer"} size={25} />
          </Link>
        </div>
      </Modal.Header>
      <div className="pd-50 text-center">
        {<BsBox size={50} />}
        <h4>Sua lista está vazia.</h4>
        <span>
          Você ainda não segue nenhum ativo, quando seguir, eles aparecerão
          aqui.
        </span>
      </div>
    </Modal>
  );
};

const loadingSkeleton = () => {
  let skeleton = (
    <div className="media">
      <div className="media-logo">
        <Skeleton width={40} height={40} borderRadius={50} />
      </div>
      <div className="media-body">
        <h6>
          <Skeleton width={120} />
        </h6>
        <span>
          <Skeleton width={100} height={10} />
        </span>
      </div>
      <div className="pd-l-10 mg-t-10">
        <Skeleton width={50} />
      </div>
    </div>
  );
  let skeletonList = [];

  for (let i = 0; i < 5; i++) {
    skeletonList.push(skeleton);
  }
  return (
    <Modal fullscreen={true} show={true} size="md">
      <Modal.Header
        style={{
          position: "sticky",
          top: 0,
          zIndex: 100,
          background: "var(--bg-1)",
        }}
      >
        <div>
          <div className="pos-relative">
            <div className="input-group-text">
              <div className="d-flex pos-absolute t-8 l-25">
                <i className="icon ion-md-search" />
              </div>
              <input
                placeholder="Pesquise por ativos..."
                className="form-control pd-l-30"
                type="text"
                value={""}
                onChange={() => false}
              />
            </div>
          </div>
        </div>
        <div>
          <Link to="/dashboard">
            <AiOutlineCloseCircle color="var(--text-1)" cursor={"pointer"} size={25} />
          </Link>
        </div>
      </Modal.Header>
      <Modal.Body className={isMobile ? "pd-5" : "pd-10"}>
        <div
          className="pd-10 mx-auto"
          style={
            isMobile
              ? { overflowY: "auto" }
              : { overflowY: "auto", height: 550 }
          }
        >
          <div className="az-profile-work-list">
            {skeletonList.map((item, i) => {
              return <div key={i}>{item}</div>;
            })}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const fatalError = () => {
  return (
    <Modal fullscreen={true} show={true} size="md">
      <Modal.Header
        style={{
          position: "sticky",
          top: 0,
          zIndex: 100,
          background: "var(--bg-1)",
        }}
      >
        <div>
          <div className="pos-relative d-none">
            <div className="input-group-text">
              <div className="d-flex pos-absolute t-8 l-25">
                <i className="icon ion-md-search" />
              </div>
              <input
                placeholder="Pesquise por ativos..."
                className="form-control pd-l-30"
                type="text"
                value={""}
                onChange={() => false}
              />
            </div>
          </div>
        </div>
        <div>
          <Link to="/dashboard">
            <AiOutlineCloseCircle color="var(--text-1)" cursor={"pointer"} size={25} />
          </Link>
        </div>
      </Modal.Header>
      <div className="pd-50 text-center">
        <span>
          <GiRocket size={48} />
        </span>
        <h4>Houston, temos um problema!</h4>
        <span>
          Infelizmente, alguns dados não aterrissaram da maneira correta.
          <br />
          <span
            onClick={() => {
              return window.location.reload();
            }}
            className="cursor-pointer tx-primary"
          >
            Clique aqui para tentar novamente.
          </span>
        </span>
      </div>
    </Modal>
  );
};
